import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import isAccessTokenValid from '@app/helpers/isAccessTokenValid'
import isUserLoggedIn from '@app/helpers/isUserLoggedIn'
import { withStyles } from '@app/components/styles'
import { saveActionStateDescription, saveActionType } from '@app/actions/scenes/currentSceneCreating'
import * as syncNotifications from '@app/actions/notifications/notificationsChannel'
import { isIOS } from 'react-device-detect'
import SelectMezzoChimesState
  from '@app/components/MyAutomation/Tabs/ScenesScreens/CreateAction/MezzoActions/SelectMezzoChimesState/SelectMezzoChimesState'
import SelectMezzoChimesStateIOS
  from '@app/components/MyAutomation/Tabs/iOS/CreateAction/MezzoActions/SelectMezzoChimesState/SelectMezzoChimesState'
import { withAccessDenied, withNotifications, withRouter } from '@app/hocs'

const isWebView = navigator.userAgent.includes('WebView') || navigator.userAgent.includes('wv')
let enhance = isIOS && isWebView ? withStyles(SelectMezzoChimesStateIOS) : withStyles(SelectMezzoChimesState)

const mapStateToProps = (state) => {
  const { isMobile } = state.mobileDetector
  const { path } = state.shadowIn
  const {
    isEditActionMode,
    isChangeActionMode,
    isChangeActionStateMode,
  } = state.scenes.currentSceneCreating
  return {
    path,
    isMobile,
    isEditActionMode,
    isChangeActionMode,
    isChangeActionStateMode,
    accessDenied: !isAccessTokenValid(state.secrets.accessToken),
    userLoggedIn: (isUserLoggedIn(state.users.currentUser.user.preferredName)),
  }
}

const mapDispatchToProps = (dispatch) => bindActionCreators({
  notifications: syncNotifications.sync,
  saveActionStateDescription,
  saveActionType,
}, dispatch)

enhance = withNotifications(enhance)
enhance = withAccessDenied(enhance)
enhance = connect(mapStateToProps, mapDispatchToProps)(enhance)

const SelectActionTypeEnhanced = enhance

export default withRouter(SelectActionTypeEnhanced)
